import Vue from "vue";
import VueRouter from "vue-router";
import store from "./store";
import App from "./App.vue";
import Main from "./components/Main";
import Terms from "./components/Terms";
import Privacy from "./components/Privacy";
import Pricing from "./components/Pricing";

Vue.use(VueRouter);
Vue.config.productionTip = false;

export const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", component: Main },
    { path: "/terms", component: Terms },
    { path: "/privacy", component: Privacy },
    { path: "/pricing", component: Pricing },
  ],
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
